<template>
  <div>
    <div v-if="!empty && !isLoading">
      <div class="buttons-wrapper">
        <button
          v-for="(button, i) in buttons"
          :key="`btn-${button.label}`"
          :class="button.activated ? 'activated' : 'desactivated'"
          :style="button.activated ? { color: color } : ''"
          :disabled="button.disabled"
          @click="() => changeButton(i)"
        >
          {{ button.label }}
        </button>
      </div>

      <div class="mb-5" v-if="buttons[0].activated && vacancies.length > 0">
        <vs-label>{{ `Vagas em aberto (${vacancy_total})` }}</vs-label>
      </div>

      <div v-if="buttons[0].activated">
        <VacancyEmptyCard
          v-if="vacancies.length === 0"
          title="Nenhuma vaga disponível"
          description="No momento não existe vagas publicadas"
        />

        <div v-else v-for="vacancy in vacancies" :key="`vacancy-${vacancy.id}`">
          <VacancyCard
            :displayUnsubscribe="buttons[1].activated"
            :vacancy="vacancy"
            :isOpen="true"
            class="mobile-hidden"
          />
          <VacancyMobileCard
            :displayUnsubscribe="buttons[1].activated"
            :vacancy="vacancy"
            :isOpen="true"
            class="sm:hidden"
          />
        </div>
        <vs-pagination
          class="my-5"
          v-if="vacancies.length > 0"
          :total="vacancy_pagination_total"
          v-model="vacancy_pagination_current"
        />
      </div>

      <div v-if="buttons[1].activated" class="mb-8">
        <vs-label>{{ `Minhas candidaturas (${application_total})` }}</vs-label>
      </div>

      <div v-if="buttons[1].activated">
        <VacancyEmptyCard
          v-if="applications.length === 0"
          title="Você ainda não se candidatou em nenhuma vaga"
          description="Candidate-se as vagas oferecidas pela empresa e aumente as suas chances de conseguir um novo trabalho"
        />

        <div v-else v-for="vacancy in applications" :key="`vacancy-${vacancy.id}`">
          <VacancyMobileCard
            :displayUnsubscribe="buttons[1].activated"
            :vacancy="vacancy"
            :isOpen="false"
            class="sm:hidden"
          />
          <VacancyCard
            :displayUnsubscribe="buttons[1].activated"
            :vacancy="vacancy"
            :application="applications[`vacancy-${vacancy.id}`]"
            :isOpen="false"
            class="mobile-hidden"
          />
        </div>
        <vs-pagination
          class="my-5"
          v-if="applications.length > 0"
          :total="application_pagination_total"
          v-model="application_pagination_current"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VacancyCard from "../../components/dashboard/VacancyCard.vue";
import VacancyMobileCard from "../../components/dashboard/VacancyMobileCard.vue";
import VacancyEmptyCard from "../../components/dashboard/profile-detail/VacancyEmptyCard.vue";
import { mapState } from "vuex";
import { get } from "lodash";

export default {
  watch: {
    vacancy_pagination_current(page) {
      this.fetchVacancyPagination(page);
    },
    application_pagination_current(page) {
      this.fetchApplicationsPagination(page);
    },
  },
  created() {
    window.scroll(0, 0);

    this.googleAnalytics();
    this.onMountButtonInAnonimous();
    this.fetchVacanciesAndApplications();
  },
  data() {
    return {
      empty: false,
      isLoading: false,
      vacancies: [],
      applications: [],
      buttons: [
        {
          label: "Vagas em Aberto",
          activated: true,
          disabled: false,
        },
        { label: "Minhas candidaturas", activated: false, disabled: false },
      ],
      vacancy_total: 0,
      vacancy_pagination_total: 1,
      vacancy_pagination_current: 1,
      vacancy_pagination_path: "",
      application_total: 0,
      application_pagination_total: 1,
      application_pagination_current: 1,
      application_pagination_path: "",
    };
  },
  computed: {
    ...mapState("company", ["company"]),

    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
    isAnonimous() {
      const label = get(this.$router, "history.current.params.company_label", null);
      return label === "anonima";
    },
  },
  methods: {
    async fetchVacanciesAndApplications() {
      try {
        this.isLoading = true;
        this.$vs.loading({ text: "Carregando..." });

        const { company_label } = this.$router.history.current.params;

        const response = await this.$http.get(
          `/api/v1/talent/${company_label}/user/talent/vacancy`
        );

        this.isLoading = false;
        this.$vs.loading.close();

        const { vacancies, applications } = response.data.data;

        this.vacancy_pagination_total = get(vacancies, 'last_page', null);
        this.application_pagination_total = get(applications, 'last_page', null);
        
        this.vacancy_pagination_path = get(vacancies, 'path', '');
        this.application_pagination_path = get(applications, 'path', '');

        this.vacancy_pagination_current = get(vacancies, 'current_page', null);
        this.application_pagination_current = get(applications, 'current_page', null);

        
        if (get(vacancies, 'data.length', 0) <= 0 && get(applications, 'data.length', 0) <= 0) {
          this.empty = true;
        }        
        
        const _applications_ids = applications.data.map((app) => app.id) || 0;

        this.vacancy_total = get(vacancies, 'total', 0) - _applications_ids.length;
        this.application_total = get(applications, 'total', 0);

        this.vacancies = get(vacancies, 'data', []).filter(
          (vacancy) => !_applications_ids.includes(vacancy.id)
        );

        this.applications = get(applications, 'data', []);
      } catch (error) {
        this.isLoading = false;
        this.$vs.loading.close();
      }
    },

    fetchApplicationsPagination(page) {
      this.$vs.loading({ text: "Carregando..." });

      this.$http
        .get(`${this.application_pagination_path}?page=${page}`)
        .then((response) => {
          this.$vs.loading.close();

          const { vacancies, applications } = response.data["data"];

          this.vacancy_total = vacancies.total;
          this.application_total = applications.total;

          this.vacancy_total = vacancies.total;
          this.application_total = applications.total;

          this.vacancy_pagination_total = vacancies.last_page;
          this.application_pagination_total = applications.last_page;

          this.vacancy_pagination_path = vacancies.path;
          this.application_pagination_path = applications.path;

          this.vacancy_pagination_current = vacancies.current_page;
          this.application_pagination_current = applications.current_page;

          if (vacancies.data.length <= 0 && applications.data.length <= 0)
            this.empty = true;

          const _applications_ids = applications.data.map((app) => app.id);

          this.vacancies = vacancies.data.filter(
            (vacancy) => !_applications_ids.includes(vacancy.id)
          );
          this.applications = applications.data;
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    fetchVacancyPagination(page) {
      this.$vs.loading({ text: "Carregando..." });

      this.$http
        .get(`${this.vacancy_pagination_path}?page=${page}`)
        .then((response) => {
          this.$vs.loading.close();

          const { vacancies, applications } = response.data["data"];

          this.vacancy_total = vacancies.total;
          this.application_total = applications.total;

          this.vacancy_pagination_total = vacancies.last_page;
          this.application_pagination_total = applications.last_page;

          this.vacancy_pagination_path = vacancies.path;
          this.application_pagination_path = applications.path;

          if (vacancies.data.length <= 0 && applications.data.length <= 0)
            this.empty = true;

          const _applications_ids = applications.data.map((app) => app.id);

          this.vacancies = vacancies.data.filter(
            (vacancy) => !_applications_ids.includes(vacancy.id)
          );
          this.applications = applications.data;
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },

    changeButton(i) {
      if (i === 1 && this.buttons[0].activated) {
        this.buttons[0].activated = !this.buttons[0].activated;
        this.buttons[i].activated = !this.buttons[i].activated;
      } else {
        this.buttons[1].activated = !this.buttons[1].activated;
        this.buttons[i].activated = !this.buttons[i].activated;
      }
    },

    onMountButtonInAnonimous() {
      if (this.isAnonimous) {
        this.buttons[0].disabled = true;
        this.buttons[0].activated = false;
        this.buttons[1].activated = true;
      }
    },

    onWithoutApplication(_vacancy) {
      return (
        this.applications.filter((application) => application.id != _vacancy.id).length >
        0
      );
    },

    countVacancy() {
      let counter = 0;

      this.vacancies.map((vacancy) =>
        this.applications.map((application) => {
          if (vacancy.id !== application.id) counter++;
        })
      );
      return counter;
    },

    googleAnalytics() {
      const { company_label } = this.$router.history.current.params;
      this.$ga.page(`${company_label}/vacancy`);
    },
  },
  components: { VacancyCard, VacancyMobileCard, VacancyEmptyCard },
};
</script>

<style lang="scss">
.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: white;
  margin-left: 0.5rem;
  border-radius: 25%;
}

.buttons-wrapper {
  display: flex;
  justify-content: center;
  margin: 20px 0 30px 0;

  button {
    width: 150px;
    background: #fff;
    padding: 8px;
    border-radius: 3px 0 0 3px;
    border: 1px solid;
    font-weight: 500;
    cursor: pointer;
  }

  button:nth-child(2) {
    border-radius: 0 3px 3px 0;
  }

  .activated {
    background: #fff;
    color: #1551b1;
  }

  .desactivated {
    background: #fafafa;
    color: #cecece;
  }
}
</style>
